import React, { useState } from 'react'
import styles from './index.module.less'
import cls from 'classnames'
import { useTranslation } from 'react-i18next'

interface ProjectListProps {
  data: any[]
  activeItem: any
  onSelect: (item: any) => void
}

const ProjectList = ({
  data = [],
  activeItem = {},
  onSelect,
}: Partial<ProjectListProps>) => {
  const { t } = useTranslation()
  return (
    <div className={styles.projectList}>
      <div className={styles.listContainer}>
        {data.map((item: any) => {
          return (
            <div
              className={cls(
                styles.projectItem,
                activeItem.projectCode === item.projectCode && styles.active
              )}
              key={item.projectCode}
              onClick={() => {
                typeof onSelect === 'function' && onSelect(item)
              }}
            >
              {item.projectCode && (
                <div className={styles.code}>{item.projectCode || ''}</div>
              )}
              {item.projectName && (
                <div className={styles.name}>{item.projectName || ''}</div>
              )}
              {item.projectTime && (
                <div className={styles.time}>{item.projectTime || ''}</div>
              )}
              {item.deleteFlag && (
                <div className={styles.time}>{t('export.projectDeleted')}</div>
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default ProjectList
